<div class="input-group">
  <input
    type="search"
    id="form1"
    class="form-control"
    attr.placeholder="{{ 'offers.search.placeholder' | translate }}"
    attr.aria-label="{{ 'offers.search.input.screenreader' | translate }}"
    [(ngModel)]="searchText"
    (input)="search()"
  />
  <button
    type="button"
    class="btn btn-primary py-0"
    attr.aria-label="{{ 'offers.search.button.screenreader' | translate }}"
    (click)="search()"
  >
    <span class="icon material-icons lh-base">search</span>
  </button>
</div>
